"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWatch = void 0;
var react_1 = require("react");
/**
 * 实时监听数据的改变，并通过callback传递回去
 *  -- 只要组件state有变化就会进入到useWatch
 *  -- 监听dep变化，然后执行callback
 *    额外增加了是否初始化立即执行callback的控制参数
 */
/**
 * @param dep 监听数据的变化
 * @param callback 数据变化执行的callback
 * @param config
 *   immediate 是否一开始的时候立即执行
 * @returns
 */
function useWatch(dep, callback, config) {
    if (config === void 0) { config = { immediate: false }; }
    var immediate = config.immediate;
    var prev = react_1.useRef();
    var inited = react_1.useRef(false);
    var stop = react_1.useRef(false);
    react_1.useEffect(function () {
        var execute = function () { return callback(prev.current); };
        if (!stop.current) {
            if (!inited.current) {
                inited.current = true;
                if (immediate) {
                    execute();
                }
            }
            else {
                execute();
            }
            prev.current = dep;
        }
    }, [dep]);
    return function () {
        stop.current = true;
    };
}
exports.useWatch = useWatch;
